import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import InfoIcon from "@mui/icons-material/Info";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import PalletLoader from "components/PalletLoader/PalletLoader";
import { userIdVerification } from "config/Services";
import { useEffect, useRef, useState } from "react";
import { emit, useNativeMessage } from "react-native-react-bridge/lib/web";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { pinMobVerify } from "../../../../config/Services";
import { useSnackbar } from "../hooks/SnackbarProvider";
import { ForgotPin } from "./forgot-pin/forgot-pin";
import { setDeviceType, setMobilePos } from "./redux/Actions/paginationActions";
import { getMobilePos } from "./redux/Reducers/paginationReducer";
import { customEventTrigger } from "../../../../analytics";
import "./LoginPage.css";
import { PosCustomButton } from "../../../../customComponents/PosCustomButton/PosCustomButton";
import palletLogo from "../../../../assets/images/pallet-logo-nav.png";
import appStoreIcon from "../../../../assets/images/app-store-icon.png";
import googlePlayIcon from "../../../../assets/images/google-play-icon.png";
import {
  SlideRestaurant, SlideMarket, SlidePharmacy,
  SlideWine, SlideBar, SlideBrewery,
  SlideFashion, SlideApparel, SlideCosmetics,
  SlideFootwear, SlideJewellery, SlideBakery,
} from "./LoginSlides";
import { CountryCodeSelect } from "./CountryCodeSelect";

const SLIDE_COMPONENTS = [
  SlideRestaurant, SlideMarket, SlidePharmacy,
  SlideWine, SlideBar, SlideBrewery,
  SlideFashion, SlideApparel, SlideCosmetics,
  SlideFootwear, SlideJewellery, SlideBakery,
];
const CAROUSEL_INTERVAL = 4000;

const LoginPage = () => {
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const [number, setNumber] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [gifTime, setGifTime] = useState(true);
  const [isVisible, setVisible] = useState(false);
  const isMobilePos = useSelector(getMobilePos);
  const [forgotPin, setForgotPin] = useState(false);
  const [changeColor, setChangeColor] = useState(false);
  const [countryDial, setCountryDial] = useState("+91");
  const dispatchAction = useDispatch();
  const location = useLocation();
  const { state } = location;

  // Carousel
  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselTimer = useRef(null);
  const startCarousel = () => {
    carouselTimer.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % SLIDE_COMPONENTS?.length);
    }, CAROUSEL_INTERVAL);
  };
  useEffect(() => {
    startCarousel();
    return () => clearInterval(carouselTimer.current);
  }, []);
  const goToSlide = (idx) => {
    clearInterval(carouselTimer.current);
    setCurrentSlide(idx);
    startCarousel();
  };

  useNativeMessage((message) => {
    const data = JSON.parse(message?.data);
    switch (message?.type) {
      case "webView": {
        if (data?.machine === "edc") dispatchAction(setMobilePos(true));
        dispatchAction(setDeviceType(data?.machine));
        break;
      }
      default:
        break;
    }
  });

  const toggle = () => setVisible((v) => !v);

  const verifyMobPin = () => {
    if (!pin) {
      showSnackbar("Please enter your pin", "error");
      return;
    }
    if (number?.length !== 10) {
      showSnackbar("Please enter a valid mobile number", "error");
      return;
    }
    const payload = { mobile: number, primaryPassword: pin };
    customEventTrigger("pos_login", { pos_login_mobile: number });

    if (!loading) {
      setLoading(true);
      pinMobVerify(payload)
        .then((response) => {
          if (response?.data?.data?.status === "ERROR") {
            setLoading(false);
            showSnackbar(response?.data?.data?.message, "error");
            return;
          }
          localStorage.setItem("access_token", response?.data?.data?.at);
          localStorage.setItem("refresh_token", response?.data?.data?.rt);
          localStorage.removeItem("CartId");

          userIdVerification(payload)
            .then(async (res) => {
              localStorage.setItem("retailUserDetails", JSON.stringify(res?.data?.data));
              if (res?.data?.data?.contexts?.POS_USER == undefined) {
                setLoading(false);
                showSnackbar("You are not authorised to log in", "error");
              } else {
                setLoading(false);
                showSnackbar("Logged In Successfully", "success");
                isMobilePos &&
                  emit({
                    type: "localData",
                    data: {
                      access_token: response?.data?.data?.at,
                      retailUserDetails: res?.data?.data,
                    },
                  });
                setTimeout(() => navigate("/products/location"), 500);
              }
            })
            .catch((err) => {
              setLoading(false);
              showSnackbar(err?.response?.data?.message || err?.message, "error");
            });
        })
        .catch((err) => {
          setLoading(false);
          showSnackbar(err?.response?.data?.message || err?.message, "error");
        });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setGifTime(false);
      localStorage.setItem("session", true);
    }, 4000);
    if (!!localStorage.getItem("access_token")) navigate("/dashboard");
  }, []);

  useEffect(() => {
    if (state?.idleLogout) setForgotPin(false);
  }, [state?.idleLogout]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Enter" && pin?.length >= 4 && !loading && !forgotPin) {
        verifyMobPin();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [pin, number, loading, forgotPin]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    verifyMobPin();
  };

  if (gifTime) {
    return <PalletLoader />;
  }
  const handleNumber = (e) => {
    const val = e?.target?.value?.replace(/\D/g, "");
    if (val?.length > 10) {
      return;
    }
    setNumber(val);
  };

  const handlePin = (e) => {
    const val = e?.target?.value?.replace(/\D/g, "").slice(0, 4);
    if (val?.length >= 4) {
      setChangeColor(true);
    } else {
      setChangeColor(false);
    }
    setPin(val);
  };
  return (
    <div className="lp-root">
      <section className="login-card-wrapper-section">
        {/* ── Pallet logo top-right ── */}
        <div className="lp-pallet-logo-wrap">
          <img src={palletLogo} alt="Pallet" className="lp-pallet-logo" />
        </div>

        {/* ── Left panel: animated carousel ── */}
        <div className="lp-left">
          <div className="lp-carousel">
            {SLIDE_COMPONENTS?.map((SlideComp, i) => (
              <div key={i} className={`lp-slide${i === currentSlide ? " active" : ""}`}>
                <SlideComp />
              </div>
            ))}
          </div>
          <div className="lp-dots">
            {SLIDE_COMPONENTS?.map((_, i) => (
              <button
                key={i}
                className={`lp-dot${i === currentSlide ? " active" : ""}`}
                onClick={() => goToSlide(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </div>

        {/* ── Right panel ── */}
        <section className="lp-right">
          <div className="lp-form-card">
            <div>
              <h2 className="lp-heading">
                {forgotPin ? "Reset forgotten PIN" : "Welcome back"}{" "}
                {forgotPin && (
                  <span style={{ marginBottom: "20px" }}>
                    {
                      <button className="lp-back-btn" onClick={() => setForgotPin(false)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          class="h-5 w-5"
                          aria-hidden="true"
                        >
                          <path d="m12 19-7-7 7-7"></path>
                          <path d="M19 12H5"></path>
                        </svg>
                      </button>
                    }
                  </span>
                )}
              </h2>
            </div>

            {!forgotPin ? (
              <form onSubmit={handleSubmit} className="lp-form">
                {/* Idle logout banner */}
                {state?.idleLogout && (
                  <div className="lp-idle-banner">
                    <InfoIcon className="lp-idle-icon" />
                    <span>
                      Hello POS User, you have been logged out due to {state?.timeoutValue / 60000}{" "}
                      minutes of inactivity
                    </span>
                  </div>
                )}

                {/* Mobile number */}
                <label className="lp-field-label">Mobile number</label>
                <div className="lp-input-wrap">
                  <CountryCodeSelect
                    value={countryDial}
                    onChange={(dial) => setCountryDial(dial)}
                  />
                  <input
                    className="lp-input"
                    type="tel"
                    placeholder="Enter mobile number"
                    autoComplete="tel"
                    autoFocus
                    value={number}
                    onChange={handleNumber}
                  />
                </div>

                {/* PIN */}
                <label className="lp-field-label">4-digit PIN</label>
                <div className="lp-pin-wrap">
                  <input
                    className="lp-input"
                    type={isVisible ? "text" : "password"}
                    placeholder="Enter secure PIN"
                    inputMode="numeric"
                    maxLength={4}
                    autoComplete="current-password"
                    value={pin || ""}
                    onChange={handlePin}
                  />
                  <button type="button" className="lp-eye-btn" onClick={toggle}>
                    {isVisible ? (
                      <VisibilityOff fontSize="small" />
                    ) : (
                      <Visibility fontSize="small" />
                    )}
                  </button>
                </div>

                {/* Forgot PIN */}
                <div className="lp-forgot">
                  <span onClick={() => setForgotPin(true)}>Forgot PIN?</span>
                </div>

                {/* Submit */}
                {/* <button
                  type="submit"
                  className={`lp-submit-btn ${changeColor && "changeBtnColor"}`}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={20} sx={{ color: "#fff" }} />
                  ) : (
                    <>
                      Login to Lynx <ArrowForwardIcon fontSize="small" />
                    </>
                  )}
                </button> */}
                {(() => {
                  const ready = number?.length === 10 && pin?.length >= 4;
                  return (
                    <PosCustomButton
                      title="Login to Lynx"
                      type="submit"
                      width="100%"
                      height="3.5rem"
                      loading={loading}
                      disabled={loading}
                      radius="24px"
                      onClickFunction={handleSubmit}
                      iconOnRight={
                        <ArrowForwardIcon
                          fontSize="small"
                          style={{ color: ready ? "#ffffff" : "#cbd5e1" }}
                        />
                      }
                      variant={ready ? "login-active" : "login-primary"}
                      p="0.5rem 1rem"
                    />
                  );
                })()}

                {/* ── Download links ── */}
                <div className="lp-download-section">
                  <p className="lp-download-title">Download Pallet Lynx on your mobile</p>
                  <div className="lp-store-links">
                    <a
                      href="https://apps.apple.com/in/app/pallet-lynx/id6746398559"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="lp-store-btn"
                    >
                      <img src={appStoreIcon} alt="" className="lp-store-img" />
                      App Store
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.palletmobilepos&hl=en_IN"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="lp-store-btn"
                    >
                      <img src={googlePlayIcon} alt="" className="lp-store-img" />
                      Google Play
                    </a>
                  </div>
                </div>

                {/* ── Register link ── */}
                <div className="lp-register-row">
                  Don't have an account?{" "}
                  <a
                    href="https://palletnow.co/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lp-register-link"
                  >
                    Register here →
                  </a>
                </div>
              </form>
            ) : (
              <>
                {/* <h2 className="lp-reset-heading">Reset PIN</h2> */}
                <ForgotPin forgotPin={forgotPin} setForgotPin={setForgotPin} />
              </>
            )}
          </div>
        </section>
      </section>
    </div>
  );
};

export default LoginPage;
